// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2z5Xj","text":"style_text__3GI0T"};